import { type TableCellProps, Td } from '@chakra-ui/react'

export function StyledTd(props: TableCellProps) {
  return <Td {...props} textStyle={'textM'} fontWeight={'medium'} />
}
